// Adapted from:
// https://thisisadvantage.com/page-transitions-using-barba-js-wordpress-elementor/

// This function helps add and remove js and css files during a page transition
const loadDependency = (filename, filetype) => {
  let asset;
  if (filetype == "js") {
    //if filename is a external JavaScript file
    const existingScript = document.querySelector(`script[src="${filename}"]`);
    if (existingScript) {
      existingScript.remove();
    }
    asset = document.createElement("script");
    asset.type = "text/javascript";
    asset.src = filename;
  } else if (filetype == "css") {
    //if filename is an external CSS file
    const existingCSS = document.querySelector(`link[href='${filename}']`);
    if (existingCSS) {
      existingCSS.remove();
    }
    asset = document.createElement("link");
    asset.rel = "stylesheet";
    asset.type = "text/css";
    asset.href = filename;
  }

  if (asset) {
    document.head.appendChild(asset);
  }

  return asset
}

const nextBodyClass = htmlString => {
  const [, newClass] = htmlString.match(/<body.*\Wclass=['"]([^'"]*)['"]/)

  if (newClass) {
    document.body.className = newClass
  }

  return document.body.className
}

const baseURL = window.location.hostname;
const protocol = window.location.protocol;
const gfPluginDir = '/wp-content/plugins/gravityforms'
const gravityFormJS = gfPluginDir + "/js/gravityforms.min.js";
const gravityFormsJquery = gfPluginDir + "/js/jquery.json.min.js";
const gformReset = gfPluginDir + "/css/formreset.min.css";
const gformMainCSS = gfPluginDir + "/css/formsmain.min.css";
const gformReadyclass = gfPluginDir + "/css/readyclass.min.css";
const gformBrowser = gfPluginDir + "/css/browsers.min.css";
const gformVariables =
  'var gf_global = {"gf_currency_config":{"name":"U.S. Dollar","symbol_left":"$","symbol_right":"","symbol_padding":"","thousand_separator":",","decimal_separator":".","decimals":2},"base_url":"' +
  protocol + "//" + baseURL + gfPluginDir +
  '","number_formats":[],"spinnerUrl":"' + protocol + "//" + baseURL + 'images/spinner.gif"};';

const initGForms = (next, gforms) => {
  // run if the page contains a form
  const gformVariablesScript = document.createElement("script");
  gformVariablesScript.innerHTML = gformVariables;
  document.body.appendChild(gformVariablesScript);

  loadDependency(gravityFormJS, "js");
  loadDependency(gravityFormsJquery, "js");
  loadDependency(gformReset, "css");
  loadDependency(gformMainCSS, "css");
  loadDependency(gformReadyclass, "css");
  loadDependency(gformBrowser, "css");

  window?.gformInitDatepicker?.();

  gforms.forEach((element) => {
    const parent = element.parentElement;
    const scripts = parent.querySelectorAll("script");
    scripts.forEach((script) => {
      const scriptCode = script.innerHTML;
      const newScript = document.createElement("script");
      script.remove();
      newScript.innerHTML = scriptCode;
      parent.appendChild(newScript);
    });
  });
}

const initElementor = (current, next, bodyClass) => {
  // ELEMENTOR
  // Where the magic happens - this loads the new Elementor styles and removes the old styles
  if (bodyClass.includes("elementor-page")) {
    let currentPageId = current.container
      .querySelector(".elementor")
      .getAttribute("data-elementor-id");
    let nextPageId = next.container
      .querySelector(".elementor")
      .getAttribute("data-elementor-id");
    let oldScriptURL =
      "/wp-content/uploads/elementor/css/post-" + currentPageId + ".css";
    let newScriptURL =
      "/wp-content/uploads/elementor/css/post-" + nextPageId + ".css"; // Add this for cache fix: ?cachebuster=' + new Date().getTime()
    const oldElementorScript = document.querySelector(
      'link[src="' + oldScriptURL + '"]'
    );
    if (oldElementorScript) {
      oldElementorScript.remove();
    }
    loadDependency(newScriptURL, "css");

    // ALLOW ELEMENTOR VIDEOS TO AUTOPLAY AFTER TRANSITION
    let elementorVideos = document.querySelectorAll(".elementor-video");

    elementorVideos?.forEach?.(video => { video.play() })
    window?.elementorFrontend?.init?.();
  }
}

export const beforeEnterWp = (current, next) => {
  // Set <body> classes for the 'next' page
  if (current.container) {
    // // only run during a page transition - not initial load
    const bodyClass = nextBodyClass(next?.html ?? '')

    const gforms = next.container.querySelectorAll(".gform_wrapper");
    if (gforms.length) {
      initGForms(next, gforms)
    }

    initElementor(current, next, bodyClass)
  }
};

/*
const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

function leaveAnimation(e) {
  return new Promise(async (resolve) => {
    await tl
      .to(e, {
        duration: 1.5,
        y: -100,
        opacity: 0,
      })
      // add any animation you like here
      .then();
    resolve();

    setTimeout(function () {
      e.style.opacity = "0";
    }, 4000);
  });
}

function enterAnimation(e) {
  return new Promise(async (resolve) => {
    await tl
      .from(e, {
        duration: 1.5,
        y: 100,
        opacity: 0,
      })
      // add any animation you like here
      .then();
    resolve();
  });
}

barba.init({
  timeout: 5000,
  debug: false, // turn this to "true" to debug
  transitions: [
    {
      sync: false,
      leave: ({ current }) => leaveAnimation(current.container),
      enter: ({ next }) => enterAnimation(next.container),
    },
  ],
});
*/